import { useEffect, useRef, useState } from "react";
import { Ifilter } from "../../../Interfaces/filter";
import { IComboBox, IComboBoxOption } from "@fluentui/react";
import { ElementoEstandarService } from "../../../services/hazard/elementoEstandarService";

export const UseComboElementoEstandar=(isOpen: boolean)=>{
    const controllerRef = useRef<AbortController>(new AbortController());
    const [filter, setFilter] = useState<Ifilter>({
        skip: 0,
        take: 20,
        search: ""
    });
    const [dataComboElemento, setDataComboElemento] = useState<IComboBoxOption[]>([]);
    const comboBoxRefElemento = useRef<IComboBox>(null);
    const onClickComboELemento = () => comboBoxRefElemento.current?.focus(true);
    const onChangeElemento = (value:any) => {
        setFilter({ ...filter, search: value });
    }
    const _onkeyUpSearchRazon = (event: React.KeyboardEvent<IComboBox>) => {
        if (event.code === "Escape") {
            comboBoxRefElemento.current?.focus(false);
            setFilter({
                skip: 0,
                take: 20,
                search: ""
            });
        } else {
            let { value } = event?.target as HTMLInputElement;
            setFilter({ ...filter, search: value });
        }
    };

    const listarCombo = () => {
        controllerRef.current.abort();
        const newController = new AbortController();
        controllerRef.current = newController;
        ElementoEstandarService.ComboElementoEstandar(filter, newController).then((res) => {
            if (res.status === 200) {
                setDataComboElemento(res.data);
            }
        });
    };

    useEffect(() => {
        if (isOpen) {
            listarCombo();
        }
    }, [isOpen]);

    useEffect(() => {
        if (filter.search != "") {
            listarCombo()
        }
    }, [filter.search])

    return {
        dataComboElemento,
        onClickComboELemento,
        _onkeyUpSearchRazon,
        comboBoxRefElemento,
        onChangeElemento,
        filter,
        setFilter
    };
}